// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__2BDGh","title":"AfterImages45_title__3wTMQ","images":"AfterImages45_images__GnETT"};